import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { videoSearchReducer } from './video-search.reducer';
import { VideoSearchEffects } from './video-search.effects';

@NgModule({
  imports: [
    StoreModule.forFeature('videoSearch', videoSearchReducer),
    EffectsModule.forFeature([VideoSearchEffects])
  ]
})
export class VideoSearchStateModule {}
